module.exports = __webpack_public_path__ + "media/images/category/feature/echigo/hero_mob-8d811ef2d465ad9f99edf63b93a0568e.jpg";